/**
 * Maps an internal provider scope (e.g. "Internal.Opennebula") to its friendly
 * product name from the central service catalog, so zone pages never surface raw
 * scopes to end users.
 */
import { SERVICE_CATEGORIES } from '@/pages/services/categories';

const SCOPE_TO_DISPLAY: Record<string, string> = (() => {
  const map: Record<string, string> = {};
  for (const category of SERVICE_CATEGORIES) {
    for (const product of category.products) {
      map[product.scope] = product.displayName;
    }
  }
  return map;
})();

export function getProviderDisplayName(scope?: string): string {
  if (!scope) return 'Private Zone';
  return SCOPE_TO_DISPLAY[scope] ?? 'Private Zone';
}
